<div class="form-group row">
  <app-custom-form-label
    [label]="label"
    [toolTip]="tooltipText"
    [required]="required"
    [showInfoAsTooltip]="showInfoAsTooltip"
    class="col-md-{{ labelSize }} col-xs-12 weight-600"
  >
  </app-custom-form-label>
  <div
    class="col-md-{{ 12 - toggleSize - labelSize }}"
    *ngIf="12 - toggleSize - labelSize > 0"
  ></div>
  <div class="col-md-{{ toggleSize }} col-xs-12">
    <nb-toggle
      [nbTooltip]="disabledMsg"
      [nbTooltipDisabled]="!disabled || !disabledMsg?.length"
      [id]="fieldId"
      [formControl]="customFormControl"
      [disabled]="disabled"
      [status]="
        customFormControl?.dirty
          ? customFormControl?.invalid
            ? 'danger'
            : 'primary'
          : 'basic'
      "
      [class]="toggleClass"
      (ngModelChange)="onChangeToggle($event)"
      [labelPosition]="toggleInbuildLabelPosition"
    >
      {{ toggleInbuildLabel }}
    </nb-toggle>
    <ng-content selector="[fieldNote]" class="mt-2"></ng-content>
  </div>
</div>
<hr *ngIf="showFormDivider" />
